import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { toggleEditMode } from '../../../shared/utils';

@Component({
  selector: 'app-vereinbarung-kommunikation',
  templateUrl: './vereinbarung-kommunikation.component.html',
  styleUrls: ['./vereinbarung-kommunikation.component.scss']
})
export class VereinbarungKommunikationComponent implements OnInit, OnChanges {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  vereinbarungKommunikation: UntypedFormControl;

  @Input()
  antrag: boolean;

  @Input()
  expertMode: boolean;

  @Input()
  showVereinbarungKommunikation = true;

  constructor(public translateService: TranslateService) { }

  static createVereinbarungKommunikation() {
    return new UntypedFormControl('', Validators.requiredTrue);
  }

  ngOnInit(): void {
    this.toggleEditMode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showVereinbarungKommunikation && changes.showVereinbarungKommunikation.currentValue !== changes.showVereinbarungKommunikation.previousValue) {
      this.toggleEditMode();
    }
  }

  toggleEditMode(): void {
    toggleEditMode(this.vereinbarungKommunikation, this.showVereinbarungKommunikation && !this.expertMode);
  }
}
